import { render } from "./MainLoader.vue?vue&type=template&id=143740dc&scoped=true&ts=true"
import script from "./MainLoader.vue?vue&type=script&lang=ts"
export * from "./MainLoader.vue?vue&type=script&lang=ts"

import "./MainLoader.vue?vue&type=style&index=0&id=143740dc&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-143740dc"]])

export default __exports__